import axiosInstance from "./axiosInstance";

export const postMappingDetails = async ({ workflow_id, mapping_json }) => {
  const payload = {
    workflow_id,
    mapping_json,
  };

  const response = await axiosInstance.post('/Save-Mapping', payload);
  return response.data;
};
